import React from 'react'
import PropTypes from 'prop-types'

import { Container, Message } from 'semantic-ui-react'

const ErrorHOC = WrappedComponent => {
  const ErrorComponent = props => {
    const { hasError } = props

    if (hasError) {
      return (
        <Container>
          <Message content="Did you try reloading or signing out and in again?" header="Something went wrong." icon="warning sign" error />
        </Container>
      )
    } else {
      return <WrappedComponent {...props} />
    }
  }

  ErrorComponent.propTypes = {
    hasError: PropTypes.bool.isRequired,
  }

  return ErrorComponent
}

export default ErrorHOC
